export default __webpack_public_path__ + "static/media/UP-BIG.6af11701.png";